import * as React from 'react';
import { CheckboxWithLabel } from '@grandvisionhq/forms';

const CreateAccount = ({ checked , errorMessage , label , onChange  })=>/*#__PURE__*/ React.createElement("div", {
        className: "checkout__create-account"
    }, /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        className: "checkout__create-account--checkbox",
        id: "createAccountDuringCheckout",
        value: "createAccountDuringCheckout",
        checked: checked,
        onChange: onChange,
        label: label,
        error: !!errorMessage,
        errorMessage: errorMessage
    }))
;

export { CreateAccount };
//# sourceMappingURL=CreateAccount.js.map
